import ImageTimeLine from "../../assets/post-login/Colleagues shifts/timeline.png";
import ImageSchedule from "../../assets/post-login/Colleagues shifts/schedule.png";
import ImageFilterModal from "../../assets/post-login/Colleagues shifts/filter-modal.png";
import { useLocalStorage } from "usehooks-ts";
import {
	ThemeSpaceVariable,
	ThemeFontSizeVariable,
	Modal,
	Button,
	Heading,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Text,
	Image,
	Stack,
	IconButton,
	BackIcon,
} from "@caspeco/casper-ui-library";
import { t } from "i18next";
import { useAppContext } from "../../hooks/use-app-context";
import { SwipeGesture } from "../../components/swipe-gesture";
import { MiniStepper } from "../../components/mini-stepper";
import { useEffect, useState } from "react";
import { isAfter } from "date-fns";

export const PostLoginOnboardingColleaguesShifts = ({ showOnboarding }: { showOnboarding: boolean }) => {
	const { safeArea } = useAppContext();
	const [onboardingComplete, setOnboardingComplete] = useLocalStorage<boolean>(
		"post-login-colleagues-shift-onboarding-complete",
		false,
	);
	const [stepCount, setStepCount] = useState<number>(1);

	useEffect(() => {
		if (!showOnboarding) {
			setOnboardingComplete(true);
		}
	}, [showOnboarding, setOnboardingComplete]);

	if (onboardingComplete || isAfter(new Date(), new Date("2026-05-01"))) {
		return null;
	}

	return (
		<Modal isOpen={true} onClose={() => setOnboardingComplete(true)}>
			<ModalHeader display={"flex"} justifyContent={"space-between"} p={ThemeSpaceVariable.Medium}>
				<IconButton
					aria-label="back"
					icon={BackIcon}
					variant="ghost"
					visibility={stepCount > 1 ? "visible" : "hidden"}
					onClick={() => {
						setStepCount(stepCount - 1);
					}}
				/>
			</ModalHeader>
			<ModalBody>
				<SwipeGesture
					swipeLeft={() => {
						if (stepCount < 4) {
							setStepCount(stepCount + 1);
						}
					}}
					swipeRight={() => {
						if (stepCount > 1) {
							setStepCount(stepCount - 1);
						}
					}}
				>
					<Stack
						gap={ThemeSpaceVariable.Medium}
						p={ThemeSpaceVariable.Medium}
						px={ThemeSpaceVariable.Large}
						w={"100%"}
					>
						{stepCount === 1 && (
							<>
								<Image src={ImageTimeLine} height={"40vh"} alignSelf={"center"} />
								<Heading
									as="h1"
									fontSize={ThemeFontSizeVariable.X2Large}
									fontWeight={"700"}
									alignSelf={"center"}
								>
									{t("post_login_onboarding_colleagues_1_title")}
								</Heading>
								<Text textAlign={"center"}>{t("post_login_onboarding_colleagues_1_description")}</Text>
							</>
						)}
						{stepCount === 2 && (
							<>
								<Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge} fontWeight={"500"}>
									{t("post_login_onboarding_colleagues_2_title")}
								</Heading>
								<Text>{t("post_login_onboarding_colleagues_2_description")}</Text>
								<Image src={ImageSchedule} height={"40vh"} alignSelf={"center"} />
							</>
						)}
						{stepCount === 3 && (
							<>
								<Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge} fontWeight={"500"}>
									{t("post_login_onboarding_colleagues_3_title")}
								</Heading>
								<Text>{t("post_login_onboarding_colleagues_3_description")}</Text>
								<Image src={ImageTimeLine} height={"40vh"} alignSelf={"center"} />
							</>
						)}
						{stepCount === 4 && (
							<>
								<Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge} fontWeight={"500"}>
									{t("post_login_onboarding_colleagues_4_title")}
								</Heading>
								<Text>{t("post_login_onboarding_colleagues_4_description")}</Text>
								<Image src={ImageFilterModal} height={"40vh"} alignSelf={"center"} />
							</>
						)}
					</Stack>
				</SwipeGesture>
			</ModalBody>
			<ModalFooter paddingBottom={safeArea.bottomAsPx()}>
				<Stack gap={ThemeSpaceVariable.Medium} p={ThemeSpaceVariable.Medium} w={"100%"} alignItems={"center"}>
					<MiniStepper activeStep={stepCount} totalSteps={4} stepCountChange={setStepCount} />
					{stepCount === 1 ? (
						<Stack width={"100%"}>
							<Button variant={"primary"} size={"lg"} w={"100%"} onClick={() => setStepCount(stepCount + 1)}>
								{t("post_login_onboarding_colleagues_yes_continue")}
							</Button>
							<Button variant={"ghost"} size={"lg"} w={"100%"} onClick={() => setOnboardingComplete(true)}>
								{t("choice_skip")}
							</Button>
						</Stack>
					) : stepCount < 4 ? (
						<Button variant={"primary"} size={"lg"} w={"100%"} onClick={() => setStepCount(stepCount + 1)}>
							{t("choice_next")}
						</Button>
					) : (
						<Button variant={"primary"} size={"lg"} w={"100%"} onClick={() => setOnboardingComplete(true)}>
							{t("choice_done")}
						</Button>
					)}
				</Stack>
			</ModalFooter>
		</Modal>
	);
};
